/**
 * Converts a SQL `SELECT` statement or `WHERE` clause into a
 * {@link index!DefaultRuleGroupType DefaultRuleGroupType} or {@link index!DefaultRuleGroupTypeIC DefaultRuleGroupTypeIC}.
 *
 * @module parseSQL
 */

export * from './parseSQL';
